exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graphs-container[data-v-01af14a4] {\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: flex-start;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n}\n.graphs-graph[data-v-01af14a4] {\n\twidth: 350px;\n\tpadding-bottom: 24px;\n\tpadding-right: 24px;\n}\n", ""]);

// exports
